<template>
    <Modal :show-footer="false" :show-title="false" @cancel="close">
        <div class="limited-modal">
            <div class="limited-modal-title">
                <span class="material-icons alert-icon">warning</span>
                {{ $t("billing.limitedModalTitle") }}
                <div style="font-size: 16px;margin-top: 10px;">
                    {{ $t("billing.limitedModalSubtitle") }}
                </div>
            </div>
            <div class="limited-modal-description">
                <div class="limited-modal-description-text">
                    {{ $t("billing.limitedModalIntro") }}
                </div>
                <div class="limited-modal-description-content">
                    <div class="information-detail" v-if="shouldSelectPlan.enabled">
                        <div class="information-detail-text">
                            <b>{{ $t("billing.limitedModalRequiredAdditions") }}</b>

                            <div class="information-detail-text-items">
                                <div v-if="shouldSelectPlan.supsisPackage">
                                    {{
                                        $t("billing.limitedModalLineAgents", {
                                            shortfall:
                                                shouldSelectPlan.details.current.users -
                                                shouldSelectPlan.details.limit.currentSupsisAgentCount,
                                            current: shouldSelectPlan.details.current.users,
                                            limit: shouldSelectPlan.details.limit.currentSupsisAgentCount,
                                        })
                                    }}
                                </div>

                                <div v-if="shouldSelectPlan.whatsappQr">
                                    {{
                                        $t("billing.limitedModalLineWhatsappQr", {
                                            shortfall:
                                                shouldSelectPlan.details.current.whatsappQr -
                                                shouldSelectPlan.details.limit.currentWhatsappPlanCount,
                                            current: shouldSelectPlan.details.current.whatsappQr,
                                            limit: shouldSelectPlan.details.limit.currentWhatsappPlanCount,
                                        })
                                    }}
                                </div>

                                <div v-if="shouldSelectPlan.whatsappBusiness">
                                    {{
                                        $t("billing.limitedModalLineWhatsappBusiness", {
                                            shortfall:
                                                shouldSelectPlan.details.current.whatsappBusinessChannels -
                                                shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount,
                                            current: shouldSelectPlan.details.current.whatsappBusinessChannels,
                                            limit: shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount,
                                        })
                                    }}
                                </div>

                                <div v-if="shouldSelectPlan.instagram">
                                    {{
                                        $t("billing.limitedModalLineInstagram", {
                                            shortfall:
                                                shouldSelectPlan.details.current.instagram -
                                                shouldSelectPlan.details.limit.instagram,
                                            current: shouldSelectPlan.details.current.instagram,
                                            limit: shouldSelectPlan.details.limit.instagram,
                                        })
                                    }}
                                </div>

                                <div v-if="shouldSelectPlan.messenger">
                                    {{
                                        $t("billing.limitedModalLineMessenger", {
                                            shortfall:
                                                shouldSelectPlan.details.current.messenger -
                                                shouldSelectPlan.details.limit.messenger,
                                            current: shouldSelectPlan.details.current.messenger,
                                            limit: shouldSelectPlan.details.limit.messenger,
                                        })
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="limited-modal-footer" style="margin-top: 30px;">
                        <SupsisButton
                            @click="confirm"
                            primary
                            style="width: 250px;"
                        >
                            {{ $t("billing.limitedModalGoPackages") }}
                        </SupsisButton>
                        <div style="margin-top: 15px; font-size: 12px; color: #666;">
                            {{ $t("billing.limitedModalFooterNote") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/common/Modal2.vue";
import { mapGetters } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "LimitedModal",
    components: {
        SupsisButton,
        Modal,
    },
    methods: {
        close() {
            this.$emit("cancel");
        },
        confirm() {
            this.$router.push("/settings/billing");
            this.$emit("cancel");
        },
    },
    computed: {
        ...mapGetters({
            shouldSelectPlan: "setting/shouldSelectPlan",
        }),
    },
};
</script>
<style lang="scss" scoped>
.limited-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .alert-icon {
        font-size: 42px;
        color: rgb(250, 102, 102);
    }

    &-title {
        font-size: medium;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;

        &-text {
            font-size: 16px;
        }

        &-content {
            font-size: 14px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .information-detail {
                &-text {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    &-items {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                    }
                }
            }
        }
    }

    &-footer {
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
    }
}
</style>
